import { render, staticRenderFns } from "./TaskDone.vue?vue&type=template&id=b67bc838&scoped=true"
import script from "./TaskDone.vue?vue&type=script&lang=js"
export * from "./TaskDone.vue?vue&type=script&lang=js"
import style0 from "./TaskDone.vue?vue&type=style&index=0&id=b67bc838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67bc838",
  null
  
)

export default component.exports